<div class="button-container" [ngClass]="{disabled: disabled, small: size==='small', secundairy: color==='secundairy'}">

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.36 47.81" width="100%" height="100%" preserveAspectRatio="none" draggable="false">
  <g class="button" id="b2dfec0e-1269-49e6-82ff-f891f90f251f" data-name="Layer 2">
    <g  id="a32bd858-5bb9-4d61-99c9-8d423c14c711" data-name="login">
      <g id="bb4b3ff9-2608-4691-8062-a444a17a1e18" data-name="Button">
        <g id="ff7f5a13-2bb4-4de5-92f7-bb2d0bbd0c76" data-name="button_down">
          <g style="opacity:0.199996992945671">
            <path d="M190.5,7.52,9.67,7.59l1.87,35s56.6-2.75,88.54-2.75,88.63,2.75,88.63,2.75Z" />
          </g>
          <path d="M195.2,1.48,5,1.55l.09,39.07,190.25-.07Z" style="fill:#f4f3f1" />
          <polygon points="188.65 8.05 11.54 8.12 11.61 34.05 188.72 33.98 188.65 8.05" class="filled" />
        </g>
        <g id="bbe37a54-3f78-4e76-b1f3-5f83a36cdf14" data-name="button">
          <g style="opacity:0.2">
            <path
              d="M195.3,6.35h-7.71L12.7,6.43H5l1.11,7.66,4,27.3L11,47.81l6.45-.73c.47,0,47.93-5.4,81.55-5.4S182.53,47,183,47l6.44.69.9-6.41L194.22,14l1.08-7.64Z" />
          </g>
          <path d="M200.26,0,0,.08.1,41.2l200.26-.07L200.26,0Z" style="fill:#fff" />
          <polygon points="193.36 6.92 6.93 6.99 7 34.29 193.43 34.22 193.36 6.92" class="filled" />
        </g>
      </g>
    </g>
  </g>
</svg>
<div class="button-caption"><span>{{caption}}<ng-content></ng-content></span></div>
</div>
